import { REQUEST_METHOD } from '@treyd-io/core/constants/request';
import { sanitizeOrgNumber } from '@treyd-io/core/utils/organization';
import request from '@treyd-io/core/utils/request';
import {
  COMPANIES_DOCUMENTS,
  COMPANY_ATTORNEY,
  COMPANY_FEES,
  COMPANY_ONBOARDING_STATUSES,
  COMPANY_STATUSES,
  CORE_COMPANY,
  DOCUMENTS_REQUEST_SIGNATURE,
  DOCUMENTS_RESEND_EMAILS,
  DOES_COMPANY_EXIST,
  REMAINING_LIMIT,
  UPDATE_COMPANIES_DOCUMENTS,
  UPDATE_COMPANY_MAIN_CONTACT,
} from '../constants/endPoints';
import {
  AddCompanyForm,
  CompanyExistsResponse,
  CompanyFees,
  CompanyStatusesResponse,
  CoreCompanyResponseData,
  Documents,
  RemainingLimitResponse,
} from '../types/merchant';
import { OnboardingStatuses } from '../types/onboarding';

export const getCompanyOnboardingStatuses = async (companyId: number) =>
  request<OnboardingStatuses>({ url: COMPANY_ONBOARDING_STATUSES(companyId) });

export const sendPOA = ({ companyId, signer_id, user_id }: Documents.Payload) =>
  request<{ payload: Documents.DocumentType }>({
    url: COMPANY_ATTORNEY(companyId),
    method: REQUEST_METHOD.POST,
    data: { signer_id, user_id },
  });

export const getCompanyDocuments = (companyId: number) =>
  request<Documents.DocumentResponse>({
    url: COMPANIES_DOCUMENTS(companyId),
  });

export const updateCompanyDocuments = ({
  companyId,
  documentId,
  data,
}: {
  companyId: number;
  documentId: number;
  data: Partial<Documents.DocumentType['data']>;
}) =>
  request<Documents.DocumentType>({
    url: UPDATE_COMPANIES_DOCUMENTS(companyId, documentId),
    method: REQUEST_METHOD.PUT,
    data: { data },
  });

export const requestDocumentSignature = ({
  companyId,
  documentId,
}: Documents.RequestSignaturePayload) =>
  request({
    url: DOCUMENTS_REQUEST_SIGNATURE('companies', companyId, documentId),
    method: REQUEST_METHOD.PUT,
  });

export const resendDocumentEmails = ({
  companyId,
  documentId,
}: Documents.ResendDocumentEmailsPayload) =>
  request({
    url: DOCUMENTS_RESEND_EMAILS('companies', companyId, documentId),
    method: REQUEST_METHOD.PUT,
  });

export const getCompanyStatuses = async (companyId: number) =>
  request<CompanyStatusesResponse>({ url: COMPANY_STATUSES(companyId) });

export const getCreditFees = (companyId: number) =>
  request<CompanyFees>({
    url: COMPANY_FEES(companyId),
  });

export const getRemainingLimit = (companyId: number) =>
  request<RemainingLimitResponse>({
    url: REMAINING_LIMIT(companyId),
  });

export const updateMainContact = ({
  companyId,
  userId,
}: {
  companyId: number;
  userId: number;
}) => {
  return request({
    url: UPDATE_COMPANY_MAIN_CONTACT(companyId),
    method: REQUEST_METHOD.PUT,
    data: { contact_id: userId },
  });
};

export const doesCompanyExists = (params: {
  country: string;
  org_no: string;
}) =>
  request<CompanyExistsResponse>({
    url: DOES_COMPANY_EXIST,
    data: params,
    method: REQUEST_METHOD.POST,
  });

export const createCoreCompany = async (params: AddCompanyForm) =>
  request<CoreCompanyResponseData>({
    url: CORE_COMPANY(
      params.country,
      sanitizeOrgNumber(params.org_no).toUpperCase()
    ),
    method: REQUEST_METHOD.POST,
  });
